import React, { useEffect, useState } from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import AdminSlotCard from './AdminSlotCard'
import AdminSlotPage from './AdminSlotPage'
import { useNavigate, useParams } from 'react-router'
import { get, post } from '../../Common/api'
import dayjs from 'dayjs'
import { notificationError, notificationSuccess } from '../../Common/Common'
import { useForm } from 'antd/es/form/Form'

export default function AdminSlot () {
  const { id } = useParams()
  const params = new URLSearchParams(location.search)
  const from = params.get('from')
  const [slot, setSlot] = useState()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [form] = useForm()

  useEffect(() => {
    setLoading(true)
    getSlot()
    setLoading(false)
  }, [])

  const screens = useBreakpoint()

  const getSlot = async () => {
    await get(`admin/slots/${id}`, {}, (json) => { setSlot(json) })
  }

  const cancel = () => {
    setLoading(true)
    post(`admin/slots/${id}/cancel`, {}, (json) => {
      setSlot(json)
      setLoading(false)
      notificationSuccess('update')
    }, () => {
      setLoading(false)
      notificationError('update')
    })
  }

  const delay = () => {
    setLoading(true)
    post(`admin/slots/${id}/delay`, {}, (json) => {
      setSlot(json)
      setLoading(false)
      notificationSuccess('update')
    }, () => {
      setLoading(false)
      notificationError('update')
    })
  }

  const back = () => {
    if (from === 'list') {
      navigate(`/admin/slots?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else if (from === 'calendar') {
      navigate(`/admin/boxes/${slot.box.id}/calendar?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else {
      navigate('/admin/events')
    }
  }

  return (
    <>
    {!screens.lg && slot && <AdminSlotCard form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} />}
    {screens.lg && slot && <AdminSlotPage form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} />}
    </>
  )
}
